import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CrudService {

  baseUrl:string = "https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images"
  baseUrl1:string = "https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs"

  constructor() { }
}
